import React from "react";
import { CpSelectMultiPills } from "@components";
import { useController } from "react-hook-form";
import { any, bool, object, string } from "prop-types";

export function CpSelectMultiPillsField(props) {
  const {
    fieldName,
    control,
    controllerOptions,
    required,
    rules = {},
    ...cpInputMultiProps
  } = props;

  const mergedRules = {
    ...rules,
    validate: {
      ...rules?.validate,
    },
  };
  if (required) {
    mergedRules.validate.isRequired = (v) => {
      return v.length || "Field is required";
    };
  }

  const {
    field: { value, onBlur, onChange, ref },
    fieldState: { error },
  } = useController({
    name: fieldName,
    control,
    rules: mergedRules,
    ...controllerOptions,
  });

  return (
    <CpSelectMultiPills
      {...cpInputMultiProps}
      error={error?.message}
      value={value}
      onBlur={onBlur}
      onChange={onChange}
      triggerRef={ref}
    />
  );
}

CpSelectMultiPillsField.propTypes = {
  control: any.isRequired,
  controllerOptions: object,
  fieldName: string.isRequired,
  rules: object,
  required: bool,
};
